function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded), sourceSymbolKeys; var key, i; if (Object.getOwnPropertySymbols) { sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useEffect } from "react";
import { nike } from "@nike/nike-design-tokens";
import { warningMessage } from "./utils/messages";
var sizeIconS = nike.sizeIconS,
    sizeIconM = nike.sizeIconM,
    sizeIconL = nike.sizeIconL;
var viewBoxes = {
  s: "0 0 ".concat(parseInt(sizeIconS), " ").concat(parseInt(sizeIconS)),
  m: "0 0 ".concat(parseInt(sizeIconM), " ").concat(parseInt(sizeIconM)),
  l: "0 0 ".concat(parseInt(sizeIconL), " ").concat(parseInt(sizeIconL))
};
var sizes = {
  s: sizeIconS,
  m: sizeIconM,
  l: sizeIconL
};
export var SvgIcon = function (_ref) {
  var ariaHidden = _ref["aria-hidden"],
      className = _ref.className,
      fill = _ref.fill,
      height = _ref.height,
      paths = _ref.paths,
      _ref$role = _ref.role,
      role = _ref$role === void 0 ? "img" : _ref$role,
      title = _ref.title,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? "m" : _ref$size,
      viewBox = _ref.viewBox,
      width = _ref.width,
      rest = _objectWithoutProperties(_ref, ["aria-hidden", "className", "fill", "height", "paths", "role", "title", "size", "viewBox", "width"]);

  var isInaccessible = function (ariaHiddenValue) {
    return !ariaHiddenValue && !title;
  };

  var ariaHiddenValue = ariaHidden;

  if (isInaccessible(ariaHidden)) {
    ariaHiddenValue = true;
  }

  var vb = viewBox ? viewBox : viewBoxes[size] || viewBoxes.m;
  var svgWidth = width ? width : sizes[size];
  var svgHeight = height ? height : sizes[size];
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    "aria-hidden": ariaHiddenValue ? "true" : "false",
    className: className,
    focusable: "false",
    viewBox: vb,
    role: role,
    width: svgWidth,
    height: svgHeight,
    fill: fill
  }, rest), (paths === null || paths === void 0 ? void 0 : paths[size]) ? paths[size] : paths === null || paths === void 0 ? void 0 : paths["m"], title && /*#__PURE__*/React.createElement("title", null, title));
};